import React, { useEffect, useState, useContext } from "react";
import BASEURL from "../../../Utils/Baseurl";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
  Step,
  StepLabel,
  Stepper,
  FormControlLabel,
  Switch,
  ButtonGroup,
  LinearProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Add, AddHome } from "@mui/icons-material";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialDatePicker from "../../../../components/MaterialDatePicker";
import MaterialTypography from "../../../../components/MaterialTypography";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { FaPeopleGroup } from "react-icons/fa6";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { request } from "graphql-request";
import { useNavigate } from "react-router-dom";
import PercentIcon from "@mui/icons-material/Percent";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { Delete } from "@mui/icons-material";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";
import { useUserDetails } from "../../../../context/auth";
import { Country, State, City } from "country-state-city";
import { date } from "yup";

const { v4: uuidv4 } = require("uuid"); // Usedn ro generate uuid\

const AddHoliday = () => {
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const { viewdisplay, setviewdisplay, AccessData } = useUserDetails();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [holidayData, setHolidayData] = useState({
    country: "",
    event: [],
    eventStatus: "unchecked",
    holidayType: "",
    startDate: "",
    endDate: "",
    eventdate: "",
    eventdateStatus: "",
    restrictedDateStatus: "",
    restrictedEventStatus: "",
    countryStatus: "unchecked",
    // holidayTypeStatus: 'unchecked',
    startDateStatus: "unchecked",
    endDateStatus: "unchecked",
  });
  console.log(holidayData,"holidayyy")

  const [samplevalue, setsamplevalue] = useState("");

  const [holidayEntries, setHolidayEntries] = useState([
    {
      id: Date.now(), // Unique ID for each entry
      event: "",
      date: "",
    },
  ]);

  console.log("holidayData:", holidayData);

  const [originalHolidayData, setoriginalHolidayData] = useState({
    country: "",
    event: "",
    holidayType: "",
    startDate: "",
    endDate: "",
  });

  const [viewswitch, setviewswitch] = useState(false);
  const [viewpublic, setviewpublic] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const onHolidaySubmit = async () => {
    const query = ` mutation addHolidays($input: [HolidayInput!]!) {
   addHoliday(input: $input) {
     holidays {
       id
       country
       event
       eventDate
       holidayType
       startDate
       endDate
     }
   }
 }`;

    const combinedHolidays = [
      ...publicHolidays.map((holiday) => ({
        country: holidayData.country,
        event: holiday.event,
        eventDate: holiday.date,
        holidayType: holiday.holidayType, // Specify holiday type
        startDate: holidayData.startDate,
        endDate: holidayData.endDate, // Adjust if holidays span multiple days
      })),
      ...restrictedHolidays.map((holiday) => ({
        country: holidayData.country,
        event: holiday.event,
        eventDate: holiday.date,
        holidayType: holiday.holidayType, // Specify holiday type
        startDate: holidayData.startDate,
        endDate: holidayData.endDate, // Adjust if holidays span multiple days
      })),
    ];

    console.log("combinedHolidays:", combinedHolidays);

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          // variables: {
          //     input: [
          //         {
          //             country: holidayData.country,
          //             event: publicHolidays.event,
          //             holidayType: holidayData.holidayType,
          //             startDate: holidayData.startDate,
          //             endDate: holidayData.endDate,
          //         },
          //     ],
          // },
          // variables: {
          //     input: publicHolidays.map((holiday) => ({
          //         country: holidayData.country,
          //         event: holiday.event,
          //         holidayType: holiday.holidayType,
          //         startDate: holidayData.startDate,
          //         endDate: holidayData.endDate, // Adjust as necessary based on your requirements
          //     })),
          // },
          variables: {
            input: combinedHolidays,
          },
        }),
      });

      let result = response.data;

      console.log("resultresult:", result);

      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Holiday Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      // Handling success
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //   ...snackBar,
      //   Success: true,
      // });
      navigate("/holiday");
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // const onHolidaySubmit = async () => {
  //     const query = `mutation addHolidays($input: [HolidayInput!]!) {
  //         addHoliday(input: $input) {
  //             holidays {
  //                 id
  //                 country
  //                 event
  //                 holidayType
  //                 startDate
  //                 endDate
  //             }
  //         }
  //     }`;

  //     try {
  //         // Prepare the input by mapping over the events array
  //         const input = holidayData.event.map((eventItem) => ({
  //             country: holidayData.country,
  //             event: eventItem.name, // Use the name property from each event object
  //             holidayType: eventItem.holidayType,
  //             startDate: holidayData.startDate,
  //             endDate: holidayData.endDate,
  //         }));

  //         const response = await axios({
  //             url: BASEURL,
  //             method: 'POST',
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //             data: JSON.stringify({
  //                 query,
  //                 variables: {
  //                     input, // Pass the array of event objects as input
  //                 },
  //             }),
  //         });

  //         const result = response.data.data.addHoliday.holidays;

  //         if (result !== "") {
  //             Swal.fire({
  //                 position: "center",
  //                 icon: "success",
  //                 title: "Holiday Submitted Successfully!",
  //                 showConfirmButton: false,
  //                 timer: 2500,
  //             });
  //         }

  //         // Handling success
  //         setConfirmationDialog({
  //             ...confirmationDialog,
  //             open: false,
  //         });
  //         setSnackBar({
  //             ...snackBar,
  //             Success: true,
  //         });
  //         navigate('/holiday');
  //     } catch (error) {
  //         console.error('responseError:', error.response.data);
  //         setConfirmationDialog({
  //             open: true,
  //             title: "Error message",
  //             message: "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
  //             showCancel: true,
  //             showConfirm: false,
  //             onCancel: () => {
  //                 setConfirmationDialog({
  //                     ...confirmationDialog,
  //                     open: false,
  //                 });
  //             },
  //         });
  //     }
  // };

  const [sampledata, setsampledata] = useState([]);

  const onEditHolidaySubmit = async () => {
    const query = `
        mutation editHoliday($id: Int!, $input: HolidayInput!) {
            editHoliday(id: $id, input: $input) {
                holidays {
                    id
                    country
                    event
                    holidayType
                    eventDate
                    startDate
                    endDate
                }
            }
        }`;

    let datavalue = [];

    if (samplevalue == "Public") {
      datavalue = publicHolidays.map((holiday) => ({
        country: holidayData.country,
        event: holiday.event,
        eventDate: holiday.date,
        holidayType: holiday.holidayType
          ? holiday.holidayType
          : "Public Holiday",
        startDate: holiday.startDate || holidayData.startDate,
        endDate: holiday.endDate || holidayData.endDate,
      }));
    } else if (samplevalue == "Restricted") {
      datavalue = restrictedHolidays.map((holiday) => ({
        country: holidayData.country,
        event: holiday.event, // Take the event from publicHolidays
        eventDate: holiday.date,
        holidayType: holiday.holidayType
          ? holiday.holidayType
          : "Restricted Holiday", // Take holidayType from holidayData
        startDate: holiday.startDate || holidayData.startDate, // Use startDate from publicHolidays if available, otherwise holidayData
        endDate: holiday.endDate || holidayData.endDate, // Same logic for endDate
      }));
    }

    console.log("input:", datavalue[0]);

    let val = datavalue[0];
    console.log("inpvalvalut:", val);
    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id, // Ensure `id` is correctly passed
            input: val, // Pass the single object here
          },
        }),
      });

      console.log("responseedit:", response.data);
      const result = response.data.data;

      if (result && result.editHoliday) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Holiday Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });

        // Navigate back to the holidays page
        navigate("/holiday");

        setSnackBar({
          ...snackBar,
          Success: true,
        });

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      }
    } catch (error) {
      console.error("responseError:", error.response?.data || error.message);

      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteSubmitHoliday();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteSubmitHoliday = async () => {
    const query = `
            mutation deleteHoliday($id: String!) {
  deleteHoliday(id: $id) {
    success
  }
}
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteHoliday.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Holiday Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/holiday");
      } else {
        console.log(
          "Error deleting Holiday:",
          response.data.data.deleteHoliday.message
        );
      }
    } catch (error) {
      console.error("An error occurred while deleting the Holiday:", error);
    }
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `query getHolidayById($id: String!) {
  holidayById(id: $id) {
    id
    country
    event
    holidayType
    startDate
    endDate
    eventDate
    
  }
}

              `;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responseeventDate:", response.data);
      // Extract Leavetype data from the response
      const holidayRowdata = response.data.data.holidayById;

      console.log("holidayRowdata", holidayRowdata);
      setHolidayData({
        country: holidayRowdata.country,
        event: holidayRowdata.event,
        holidayType: holidayRowdata.holidayType,
        startDate: holidayRowdata.startDate,
        endDate: holidayRowdata.endDate,
      });
      if (holidayRowdata.holidayType == "Public Holiday") {
        setPublicHolidays([
          ...publicHolidays,
          // { id: uuidv4(), state: "new" },
          { event: holidayRowdata.event, date: holidayRowdata.eventDate },
        ]);
        setsamplevalue("Public");
        setviewswitch(true);
        setviewpublic(false);
      } else if (holidayRowdata.holidayType == "Restricted Holiday") {
        setRestrictedHolidays([
          ...restrictedHolidays,
          { event: holidayRowdata.event, date: holidayRowdata.eventDate },
        ]);
        setsamplevalue("Restricted");
        setviewswitch(false);
        setviewpublic(true);
      }

      setoriginalHolidayData({
        country: holidayRowdata.country,
        event: holidayRowdata.event,
        holidayType: holidayRowdata.holidayType,
        startDate: holidayRowdata.startDate,
        endDate: holidayRowdata.endDate,
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        message:
          "We are unable to fetch the required data at this time. Please try again later. If the problem persists, please contact support.",
        state: "error",
      });
    }
  };

  const handleEventChange = (event) => {
    const value = event; // Trim whitespace
    const descriptionRegex = new RegExp("^([\\s\\S]{10,100})$");

    setHolidayData((prevData) => {
      const updatedEvents = Array.isArray(prevData.event)
        ? [...prevData.event] // Copy existing events
        : []; // Initialize as an array if it's not already

      // Check if there's already a pending event being edited
      const lastEvent = updatedEvents[updatedEvents.length - 1];

      if (
        lastEvent &&
        lastEvent.eventStatus === "error" &&
        lastEvent.name.startsWith(value)
      ) {
        // Update the current event instead of creating a new one
        lastEvent.name = value;
        lastEvent.eventStatus = descriptionRegex.test(value)
          ? "success"
          : "error";
        lastEvent.holidayType = value.toLowerCase().includes("restricted")
          ? "RestrictedHoliday"
          : "PublicHoliday";
      } else {
        // Add or replace the event when typing a new value
        updatedEvents.push({
          name: value,
          eventStatus: descriptionRegex.test(value) ? "success" : "error",
          holidayType: value.toLowerCase().includes("restricted")
            ? "RestrictedHoliday"
            : "PublicHoliday",
        });
      }

      return {
        ...prevData,
        event: updatedEvents, // Update the events array
      };
    });
  };

  const handlestartdate = (selectedDates) => {
    if (selectedDates.length > 0) {
      let val = selectedDates[0];
      let formattedDate = new Date(
        val.getTime() - val.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0]; // Ensures local timezone is used correctly
      console.log("Formatted Start Date:", formattedDate);

      setHolidayData({
        ...holidayData,
        startDate: formattedDate,
        startDateStatus: "success",
      });
    }
  };

  const handleenddate = (selectedDates) => {
    if (selectedDates.length > 0) {
      let val = selectedDates[0];
      let formattedDate = new Date(
        val.getTime() - val.getTimezoneOffset() * 60000
      )
        .toISOString()
        .split("T")[0]; // Ensures local timezone is used correctly
      console.log("Formatted Start Date:", formattedDate);

      setHolidayData({
        ...holidayData,
        endDate: formattedDate,
        endDateStatus: "success",
      });
    }
  };

  const handleHolidayDatachange = (event) => {
    let holidayState = { ...holidayData };

    switch (event.target.name) {
      // case "country": {
      //   const descriptionRegex = new RegExp("^([a-zA-Z ]{1,20})$");

      //   holidayState[event.target.name + "Status"] = descriptionRegex.test(
      //     event.target.value?.trim()
      //   )
      //     ? "success"
      //     : event.target.value === ""
      //     ? "unchecked"
      //     : "error";
      //   holidayState[event.target.name] = event.target.value;
      //   break;
      // }

      case "event": {
        // Call handleEventChange for the event-specific logic
        handleEventChange(event.target.value);
        return; // Exit the function after calling handleEventChange to avoid redundant updates
      }

      case "startDate": {
        holidayState[event.target.name + "Status"] = event.target.value?.trim()
          ? "success"
          : event.target.value === ""
          ? "unchecked"
          : "error";
        holidayState[event.target.name] = event.target.value;
        break;
      }

      case "endDate": {
        holidayState[event.target.name + "Status"] = event.target.value?.trim()
          ? "success"
          : event.target.value === ""
          ? "unchecked"
          : "error";
        holidayState[event.target.name] = event.target.value;
        break;
      }

      case "holidayType": {
        holidayState.holidayType = event.target.checked;
        holidayState.holidayTypeStatus = event.target.checked
          ? "success"
          : "unchecked";
        break;
      }

      default:
        break;
    }

    setHolidayData(holidayState); // Update the state with the modified holidayState for other cases
  };

  const handleHolidaycountry = (selectedOption, fieldName) => {
    let holidayState = { ...holidayData };

    if (fieldName === "country") {
      const lengthRegex = /^[A-Za-z0-9\s]+$/; // Allow alphanumeric and spaces
      if (lengthRegex.test(selectedOption?.label)) {
        holidayState["countryStatus"] = "success";
        holidayState["country"] = selectedOption?.value; // Update country value
      } else {
        holidayState["countryStatus"] = "error";
      }
    }

    setHolidayData(holidayState); // Update the state with the modified holidayState
  };

  const handleAddHoliday = () => {
    // setPageState({
    //   ...pageState,
    //   state: "submitting",
    // });
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onHolidaySubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const onDiscardHoliday = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setHolidayData({
      country: originalHolidayData.country,
      event: originalHolidayData.event,
      holidayType: originalHolidayData.holidayType,
      startDate: originalHolidayData.startDate,
      endDate: originalHolidayData.endDate,
    });
  };
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      holidayData.countryStatus === "success" &&
      // holidayData.holidayTypeStatus === 'success' &&
      holidayData.endDateStatus === "success" &&
      holidayData.eventStatus === "success" &&
      holidayData.eventdateStatus === "success" &&
      holidayData.restrictedDateStatus === "success" &&
      holidayData.restrictedEventStatus === "success" &&
      holidayData.startDateStatus === "success" &&
      publicHolidays?.length > 0
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      holidayData.country === originalHolidayData.country &&
      holidayData.event === originalHolidayData.event &&
      holidayData.holidayType === originalHolidayData.holidayType &&
      holidayData.startDate === originalHolidayData.startDate &&
      holidayData.endDate === originalHolidayData.endDate
    ) {
      allowSubmit = false;
    } else if (holidayData.country !== originalHolidayData.country) {
      if (holidayData.countryStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    }
    // else if (holidayData.event !== originalHolidayData.event) {
    //     if (holidayData.eventstatus === 'success') {
    //         allowSubmit = true
    //     }
    //     else {
    //         allowSubmit = false
    //     }
    // }
    else if (holidayData.holidayType !== originalHolidayData.holidayType) {
      if (holidayData.holidayTypeStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (holidayData.startDate !== originalHolidayData.startDate) {
      if (holidayData.startDateStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (holidayData.endDate !== originalHolidayData.endDate) {
      if (holidayData.endDateStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const [isHolidayAdded, setIsHolidayAdded] = useState(false);
  const [isRestircAdded, setRestircAdded] = useState(false);
  
  const confirmDeletePublic = (id) => {
    setIsHolidayAdded(false);
    setPublicHolidays(publicHolidays.filter((holiday) => holiday.id !== id));
  };

  const confirmDeleteRestricted = (id) => {
    setRestircAdded(false)
    setRestrictedHolidays(
      restrictedHolidays.filter((holiday) => holiday.id !== id)
    );
  };
  const onAddPublicHoliday = () => {
    setIsHolidayAdded(true);
    setPublicHolidays([...publicHolidays, { id: uuidv4(), state: "new" }]);
  };

  const onAddRestrictedHoliday = () => {
    setRestircAdded(true)
    setRestrictedHolidays([
      ...restrictedHolidays,
      { id: uuidv4(), state: "new" },
    ]);
  };

  const [publicHolidays, setPublicHolidays] = useState([]);
  const [restrictedHolidays, setRestrictedHolidays] = useState([]);
  const [holiday, setHoliday] = useState([
    {
      id: uuidv4(),
      state: "new",
    },
  ]);

  console.log("publicHolidays:", publicHolidays);

  // const handleHoliday = (e, id) => {
  //   const { name, value } = e.target;

  //   setPublicHolidays((prevHolidays) =>
  //     prevHolidays.map((holiday) =>
  //       holiday.id === id
  //         ? { ...holiday, [name]: value, holidayType: "Public Holiday" }
  //         : holiday
  //     )
  //   );
  //   setHolidayData({
  //     ...holidayData,
  //     eventStatus: "success",
  //   });
  // };

  const handleHoliday = (selectedDates, id, isDate = false) => {
    let name, value;

    if (isDate) {
      // If it's a date picker event
      name = "date";
      if (selectedDates.length > 0) {
        let val = selectedDates[0];

        value = new Date(val.getTime() - val.getTimezoneOffset() * 60000)
          .toISOString()
          .split("T")[0];
      } else {
        value = "";
      }

      setHolidayData((prevState) => ({
        ...prevState,
        eventdateStatus: "success",
      }));
    } else {
      // If it's a regular input event
      // ({ name, value } = selectedDates.target);

      ({ name, value } = selectedDates.target);

      if (name === "event") {
        const regex = /^[A-Za-z\s]{1,50}$/;

        let status = "success";
        let errorMessage = "";

        if (!value.trim()) {
          status = "error";
          errorMessage = "Event is Mandatory";
        } else if (!regex.test(value)) {
          status = "error";
          errorMessage = "Only alphabets allowed (Max 50 chars)";
        }

        setHolidayData((prevState) => ({
          ...prevState,
          eventStatus: status,
          eventErrorMessage: errorMessage,
        }));
      }
    }
    setPublicHolidays((prevHolidays) =>
      prevHolidays.map((holiday) =>
        holiday.id === id
          ? { ...holiday, [name]: value, holidayType: "Public Holiday" }
          : holiday
      )
    );

    setHolidayData((prevState) => ({
      ...prevState,
      eventStatus: "success",
    }));

    console.log(`Updated ${name}:`, value);
  };

  // const handlerestricte = (e, id) => {
  //   const { name, value } = e.target;

  //   setRestrictedHolidays((prevHolidays) =>
  //     prevHolidays.map((holiday) =>
  //       holiday.id === id
  //         ? { ...holiday, [name]: value, holidayType: "Restricted Holiday" }
  //         : holiday
  //     )
  //   );
  // };

  const handlerestricte = (selectedDates, id, isDate = false) => {
    let name, value;

    if (isDate) {
      // If it's a date picker event
      name = "date";
      if (selectedDates.length > 0) {
        let val = selectedDates[0];
        value = new Date(val.getTime() - val.getTimezoneOffset() * 60000)
          .toISOString()
          .split("T")[0]; // Convert to YYYY-MM-DD while handling timezones correctly
      } else {
        value = ""; // If no date is selected, reset value
      }

      // ✅ Update only date-related status
      setHolidayData((prevState) => ({
        ...prevState,
        restrictedDateStatus: "success",
      }));
    } else {
      // If it's a regular input event
      ({ name, value } = selectedDates.target);

      if (name === "event") {
        const regex = /^[A-Za-z\s]{1,50}$/; // ✅ Allows alphabets & spaces, max 50 chars
        let status = holidayData.restrictedEventStatus; // Keep the existing status
        let errorMessage = holidayData.restrictedEventErrorMessage || "";

        if (!value.trim()) {
          status = "error";
          // errorMessage = "Event is Mandatory";
        } else if (!regex.test(value)) {
          status = "error";
          errorMessage = "Only alphabets allowed (Max 50 chars)";
        } else {
          status = "success"; // ✅ Only set success when valid
          errorMessage = "";
        }

        setHolidayData((prevState) => ({
          ...prevState,
          restrictedEventStatus: status, // ✅ Now updates only when needed
          restrictedEventErrorMessage: errorMessage,
        }));
      }
    }

    // ✅ Update restricted holiday list after validation
    setRestrictedHolidays((prevHolidays) =>
      prevHolidays.map((holiday) =>
        holiday.id === id
          ? { ...holiday, [name]: value, holidayType: "Restricted Holiday" }
          : holiday
      )
    );

    console.log(`Updated ${name}:`, value);
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/holiday");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the holiday details for you. This
                    may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                      {togglePage.view ? "View Holiday Details" : "Edit Holiday Details"}

                         
                      </MaterialTypography>
                    </Stack>
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "AddHoliday" && item.can_access
                      ) &&
                      pageState.state !== "submitting" && (
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Holiday Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}
            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1.5}>
                  <Grid size={{ xs: 3, sm: 3 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Country <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    {/* <MaterialInput
                      name="country"
                      placeholder="Eg. country"
                      value={holidayData.country}
                      onChange={handleHolidayDatachange}
                      error={holidayData.countryStatus === "error"}
                      success={holidayData.countryStatus === "success"}
                      disabled={togglePage.view}
                    /> */}
                    <MaterialSelect
                      name="country"
                      value={
                        holidayData.country
                          ? {
                              value: holidayData.country,
                              label: holidayData.country,
                            }
                          : null
                      }
                      customStyles={{ optionPadding: 20 }}
                      onChange={(selectedOption) =>
                        handleHolidaycountry(selectedOption, "country")
                      }
                      options={Country.getAllCountries().map((value) => {
                        return {
                          value: value?.name,
                          label: value?.name,
                          isoCode: value?.isoCode,
                        };
                      })}
                      error={holidayData.countryStatus === "error"}
                      success={holidayData.countryStatus === "success"}
                      isDisabled={togglePage.view === true ? true : false}
                      // isClearable
                    />
                    {holidayData.countryStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Country Name should be contain only alphabets
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid size={{ xs: 3, sm: 3 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Start Date <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialDatePicker
                      // name="startDate"
                      type="date"
                      // inputProps={{
                      //   min: new Date().toISOString().split("T")[0],
                      // }}
                      
                      onChange={handlestartdate}
                      value={holidayData.startDate}
                      error={holidayData.startDateStatus === "error"}
                      success={holidayData.startDateStatus === "success"}
                      disabled={togglePage.view}
                    />
                  </Grid>
                  <Grid size={{ xs: 3, sm: 3 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                       Valid Till <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialDatePicker
                      options={{
                        minDate: holidayData.startDate, // Ensures end date is not before start date
                      }}
                      onChange={handleenddate}
                      value={holidayData.endDate}
                      error={holidayData.endDateStatus === "error"}
                      success={holidayData.endDateStatus === "success"}
                      disabled={togglePage.view}
                    />
                  </Grid>
                  <Grid size={{ xs: 3, sm: 3 }}>
                    {!viewswitch && (
                      <FormControlLabel
                        control={
                          <Switch
                            checked={holidayData.holidayType} // Bind to state
                            name="holidayType" // The name for this switch
                            onChange={handleHolidayDatachange} // Handle change
                            disabled={togglePage.view}
                          />
                        }
                        label={
                          holidayData.holidayType ? (
                            <MaterialTypography variant="caption" color="text">
                              Restricted Holiday{" "}
                              <span style={{ color: "red", fontSize: "20px" }}>
                                *
                              </span>
                            </MaterialTypography>
                          ) : (
                            <MaterialTypography variant="caption" color="text">
                              Restricted Holiday{" "}
                              <span style={{ color: "red", fontSize: "20px" }}>
                                *
                              </span>
                            </MaterialTypography>
                          )
                        }
                      />
                    )}
                  </Grid>
                </Grid>
              </MaterialBox>
            )}
            {!viewpublic && (
              <MaterialBox>
                <MaterialTypography
                  sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                  variant="h5"
                  fontWeight="bold"
                >
                  Public Holiday <span style={{ color: "red" }}>*</span>
                </MaterialTypography>

                <MaterialBox>
                  {publicHolidays.map((day, index) => (
                    <MaterialBox key={day.id}>
                      <Grid container spacing={1}>
                        {/* S.No Label + Input */}
                        <Grid item xs={12} md={2.5}>
                          <MaterialBox
                            mb={1}
                            ml={0.5}
                            lineHeight={0}
                            textAlign="left"
                          >
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              S.No
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="sNo"
                            value={index + 1}
                            readOnly
                            disabled={togglePage.view}
                          />
                        </Grid>
                        {/* Event Label + Input */}
                        <Grid item xs={12} md={2.5}>
                          <MaterialBox
                            mb={1}
                            ml={0.5}
                            lineHeight={0}
                            textAlign="left"
                          >
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              Event <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="event"
                            placeholder="Event"
                            value={day.event}
                            error={holidayData.eventStatus === "error"}
                            onChange={(e) => handleHoliday(e, day.id)}
                            disabled={togglePage.view}
                          />
                          {holidayData.eventErrorMessage !== "" && (
                            <FormControl error>
                              <FormHelperText>
                                {holidayData.eventErrorMessage}
                              </FormHelperText>
                            </FormControl>
                          )}
                        </Grid>
                        {/* Date Label + Input */}
                        <Grid item xs={12} md={2.5}>
                          <MaterialBox
                            mb={1}
                            ml={0.5}
                            lineHeight={0}
                            textAlign="left"
                          >
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              Date <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialDatePicker
                            name="date"
                            placeholder="Date"
                            type="date"
                            options={{
                              minDate: holidayData.startDate, // Set the minimum selectable date
                              maxDate: holidayData.endDate, // Set the maximum selectable date
                            }}
                            value={day.date}
                            onChange={(selectedDates) =>
                              handleHoliday(selectedDates, day.id, true)
                            }
                            disabled={togglePage.view}
                          />
                        </Grid>
                        {/* Delete Button */}
                        {!viewdisplay && (
                          <Grid item xs={12} md={2}>
                            <MaterialButton
                              onClick={() => confirmDeletePublic(day.id)}
                              variant="gradient"
                              color="error"
                              fullWidth
                              sx={{ marginTop: "30%" }}
                            >
                              <Delete color="inherit" />
                            </MaterialButton>
                          </Grid>
                        )}
                      </Grid>
                      <Divider sx={{mt: 1}} />
                    </MaterialBox>
                  ))}
                </MaterialBox>
                <MaterialBox sx={{ mt: isHolidayAdded ? '-2px' : '2px' }}>
                {!viewdisplay && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    startIcon={<Add />}
                    onClick={onAddPublicHoliday}
                    mb={0}
                    pb={0}
                  >
                    Add
                  </MaterialButton>
                )}
                </MaterialBox>
               
              </MaterialBox>
            )}
            {!viewswitch && holidayData.holidayType && (
              <MaterialBox>
                <MaterialTypography
                  sx={{ mt: 2, mb: 1, color: "rgba(63, 81, 181, 0.83)" }}
                  variant="h5"
                  fontWeight="bold"
                >
                  Restricted Holiday
                </MaterialTypography>
                <MaterialBox>
                  {restrictedHolidays.map((day, index) => (
                    <MaterialBox key={day.id}>
                      <Grid container spacing={1}>
                        {/* S.No Label + Input */}
                        <Grid item xs={12} md={2}>
                          <MaterialBox
                            mb={1}
                            ml={0.5}
                            lineHeight={0}
                            textAlign="left"
                          >
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              S.No
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="sNo"
                            value={index + 1}
                            readOnly
                            disabled={togglePage.view}
                          />
                        </Grid>

                        {/* Event Label + Input */}
                        <Grid item xs={12} md={4}>
                          <MaterialBox
                            mb={1}
                            ml={0.5}
                            lineHeight={0}
                            textAlign="left"
                          >
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                            >
                              Event <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          <MaterialInput
                            name="event"
                            placeholder="Event"
                            value={day.event}
                            disabled={togglePage.view}
                            onChange={(e) => handlerestricte(e, day.id)}
                          />
                          {holidayData.restrictedEventErrorMessage !== "" && (
                            <FormControl error>
                              <FormHelperText>
                                {holidayData.restrictedEventErrorMessage}
                              </FormHelperText>
                            </FormControl>
                          )}
                        </Grid>

                        {/* Date Label + Input */}
                        <Grid item xs={12} md={4}>
                          <MaterialBox
                            mb={1}
                            ml={0.5}
                            lineHeight={0}
                            textAlign="left"
                          >
                            <MaterialTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                             
                            >
                              Date <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                          </MaterialBox>
                          {/* <MaterialInput
                            name="date"
                            placeholder="Date"
                            type="date"
                            value={day.date}
                            onChange={(e) => handlerestricte(e, day.id)}
                          /> */}
                          <MaterialDatePicker
                            name="date"
                            placeholder="Date"
                            disabled={togglePage.view}
                            type="date"
                            options={{
                              minDate: holidayData.startDate, // Set the minimum selectable date
                              maxDate: holidayData.endDate,
                            }}
                            value={day.date}
                            onChange={(selectedDates) =>
                              handlerestricte(selectedDates, day.id, true)
                            }
                          />
                        </Grid>

                        {/* Delete Button */}
                        {!viewdisplay && (
                          <Grid item xs={12} md={2}>
                            <MaterialButton
                              onClick={() => confirmDeleteRestricted(day.id)}
                              variant="gradient"
                              color="error"
                              sx={{ marginTop: "30%" }}
                              fullWidth
                            >
                              <Delete color="inherit" />
                            </MaterialButton>
                          </Grid>
                        )}
                      </Grid>
                      <Divider sx={{mt: 1}} />
                    </MaterialBox>
                  ))}
                </MaterialBox>
                <MaterialBox sx={{ mt: isRestircAdded ? '-2px' : '2px' }}>
                {!viewdisplay && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    startIcon={<Add />}
                    onClick={onAddRestrictedHoliday} // Update to add restricted holiday
                    // mb={0}
                    // pb={0}
                  >
                    Add
                  </MaterialButton>
                )}
                </MaterialBox>
               
              </MaterialBox>
            )}
            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your holidaySubmit data. This should not take much
                    time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={onDiscardHoliday}
                  >
                    Discard
                  </MaterialButton>

                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={onEditHolidaySubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handlecancel}
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2, marginLeft: "4px" }}
                    variant="gradient"
                    color="dark"
                    disabled={
                      !checkAllFields() || pageState.state === "submitting"
                    }
                    // startIcon={<AddIcon />}
                    onClick={handleAddHoliday}
                  >
                    Submit
                  </MaterialButton>
                </>
              ) : null}
            </MaterialBox>
          )}
          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddHoliday;
